import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { obtenerIndices } from '../../actions/listados'
import IndicesDeMermaCalidadView from '../../components/listados/IndicesDeMermaCalidadView'

function IndicesDeMermaCalidad (props) {
  const { obtenerIndices } = props

  useEffect(() => {
    obtenerIndices()
  }, [obtenerIndices])

  return (
    <IndicesDeMermaCalidadView />
  )
}

const mapActionsToProps = {
  obtenerIndices
}

const withRedux = connect(null, mapActionsToProps)
export default withRedux(IndicesDeMermaCalidad)
